import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { theme } from '../../../../theme';

const { colors, filters } = theme;

export const InputBlock = styled.div`
  position: relative;
`;

export const FontAwesomeIconCalendar = styled(FontAwesomeIcon)`
  position: absolute;
  top: 9px;
  left: 9px;
  cursor: none;
`;

export const Input = styled.input`
  width: 260px;
  height: 30px;
  box-sizing: border-box;
  margin: 0;
  padding: 8px 30px;
  font-size: 10.8px;
  background-color: ${colors.white};
  font-weight: 500 !important;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid ${colors.textPrimary};
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    outline: 0;
  }
`;

export const DivPopup = styled.div<{ isOpen: boolean }>`
  ${(props) =>
    props &&
    css`
      position: absolute;
      margin-top: 8px;
      width: 260px;
      height: 261px;
      box-sizing: border-box;
      border-radius: 5px;
      z-index: 100;
      background: ${colors.disabledButtonBG};
      overflow: hidden;
      display: ${props.isOpen ? 'block' : 'none'};
    `};
`;

const ButtonPopup = styled.button<{ isActive?: boolean }>`
  ${(props) =>
    props &&
    css`
      line-height: 1.5;
      text-align: left;
      color: ${props.isActive ? colors.white : colors.textPrimary};
      background: ${props.isActive ? colors.active : 'unset'};
      user-select: none;
      display: flex;
      border: none;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      float: left;
      outline: 1px solid ${filters.lightGrayHover};
      word-break: break-word;
      text-transform: capitalize;
      cursor: pointer;
      font-weight: 700;
      height: 33.33%;
      font-size: 15px;

      &:hover,
      &:focus {
        background: ${filters.activeLight};
        color: ${colors.white};
        outline: 1px solid ${filters.lightGrayHover};
      }
    `};
`;

export const ButtonMonth = styled(ButtonPopup)`
  width: 25%;
`;

export const ButtonYears = styled(ButtonPopup)`
  width: 20%;
`;

export const ButtonAngle = styled(ButtonYears)`
  background: ${colors.white};
  color: ${filters.activeLight};

  &:hover {
    background: ${filters.activeLight};
    color: ${colors.white};
  }

  &:focus {
    background: ${colors.white};
    color: ${filters.activeLight};
  }
`;

export const DivDatepicker = styled.div`
  & .datepicker {
    display: none;
    width: 0;
    height: 0;
    padding: 0;
    margin: 0;
    position: absolute;
    opacity: 0;
  }

  & > div {
    .flatpickr-calendar {
      background: transparent;
      opacity: 0;
      display: none;
      text-align: center;
      visibility: hidden;
      padding: 0;
      animation: none;
      direction: ltr;
      border: 0;
      font-size: 14px;
      line-height: 24px;
      border-radius: 5px;
      position: absolute;
      width: 308px;
      box-sizing: border-box;
      touch-action: manipulation;
      background: ${colors.white};
    }
    .flatpickr-calendar.open,
    .flatpickr-calendar.inline {
      opacity: 1;
      max-height: 640px;
      visibility: visible;
    }
    .flatpickr-calendar.open {
      display: inline-block;
      z-index: 99999;
    }
    .flatpickr-calendar.animate.open {
      animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
    }
    .flatpickr-calendar.inline {
      display: block;
      position: relative;
      top: 4px;
      margin-bottom: 30px;
    }
    .flatpickr-calendar.static {
      position: absolute;
      top: calc(100% + 2px);
    }
    .flatpickr-calendar.static.open {
      z-index: 999;
      display: block;
    }
    .flatpickr-calendar.multiMonth
      .flatpickr-days
      .dayContainer:nth-child(n + 1)
      .flatpickr-day.inRange:nth-child(7n + 7) {
      box-shadow: none !important;
    }
    .flatpickr-calendar.multiMonth
      .flatpickr-days
      .dayContainer:nth-child(n + 2)
      .flatpickr-day.inRange:nth-child(7n + 1) {
      box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
    }
    .flatpickr-calendar .hasWeeks .dayContainer,
    .flatpickr-calendar .hasTime .dayContainer {
      border-bottom: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
    .flatpickr-calendar .hasWeeks .dayContainer {
      border-left: 0;
    }
    .flatpickr-calendar.hasTime .flatpickr-time {
      height: 40px;
      border-top: 1px solid #eee;
    }
    .flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
      height: auto;
    }
    .flatpickr-calendar:before,
    .flatpickr-calendar:after {
      position: absolute;
      display: block;
      pointer-events: none;
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      left: 22px;
    }
    .flatpickr-calendar.rightMost:before,
    .flatpickr-calendar.arrowRight:before,
    .flatpickr-calendar.rightMost:after,
    .flatpickr-calendar.arrowRight:after {
      left: auto;
      right: 22px;
    }
    .flatpickr-calendar.arrowCenter:before,
    .flatpickr-calendar.arrowCenter:after {
      left: 50%;
      right: 50%;
    }
    .flatpickr-calendar:before {
      border-width: 5px;
      margin: 0 -5px;
    }
    .flatpickr-calendar:after {
      border-width: 4px;
      margin: 0 -4px;
    }
    .flatpickr-calendar.arrowTop:before,
    .flatpickr-calendar.arrowTop:after {
      bottom: 100%;
    }
    .flatpickr-calendar.arrowTop:before {
      border-bottom-color: #eee;
    }
    .flatpickr-calendar.arrowTop:after {
      border-bottom-color: ${colors.white};
    }
    .flatpickr-calendar.arrowBottom:before,
    .flatpickr-calendar.arrowBottom:after {
      top: 100%;
    }
    .flatpickr-calendar.arrowBottom:before {
      border-top-color: #eee;
    }
    .flatpickr-calendar.arrowBottom:after {
      border-top-color: ${colors.white};
    }
    .flatpickr-calendar:focus {
      outline: 0;
    }
    .flatpickr-wrapper {
      position: relative;
      display: inline-block;
    }
    .flatpickr-months {
      display: flex;
      border-bottom: 1px solid #ddd;
    }
    .flatpickr-months .flatpickr-month {
      background: transparent;
      color: #3c3f40;
      fill: #3c3f40;
      height: 34px;
      line-height: 1;
      text-align: center;
      position: relative;
      user-select: none;
      overflow: hidden;
      flex: 1;
    }
    .flatpickr-months .flatpickr-prev-month,
    .flatpickr-months .flatpickr-next-month {
      text-decoration: none;
      cursor: pointer;
      position: absolute;
      top: 0;
      height: 34px;
      padding: 5px 10px;
      z-index: 3;
      color: #3c3f40;
      fill: #3c3f40;
    }
    .flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
    .flatpickr-months .flatpickr-next-month.flatpickr-disabled {
      display: none;
    }
    .flatpickr-months .flatpickr-prev-month i,
    .flatpickr-months .flatpickr-next-month i {
      position: relative;
    }
    .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
      left: 0;
    }
    .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
      right: 0;
    }
    .flatpickr-months .flatpickr-prev-month svg,
    .flatpickr-months .flatpickr-next-month svg {
      width: 14px;
      height: 14px;
    }
    .flatpickr-months .flatpickr-prev-month svg path,
    .flatpickr-months .flatpickr-next-month svg path {
      transition: fill 0.1s;
      fill: inherit;
    }
    .numInputWrapper {
      width: 45px;
      position: relative;
      height: auto;
    }
    .numInputWrapper input,
    .numInputWrapper span {
      display: none;
      cursor: pointer !important;
    }
    .numInputWrapper input {
      width: 100%;
    }
    .numInputWrapper input::-ms-clear {
      display: none;
    }
    .numInputWrapper input::-webkit-outer-spin-button,
    .numInputWrapper input::-webkit-inner-spin-button {
      margin: 0;
      display: none;
    }
    .numInputWrapper span {
      position: absolute;
      right: 0;
      width: 14px;
      padding: 0 4px 0 2px;
      height: 50%;
      line-height: 50%;
      opacity: 0;
      cursor: pointer;
      border: 1px solid rgba(64, 72, 72, 0.15);
      box-sizing: border-box;
    }
    .numInputWrapper span:hover {
      background: rgba(0, 0, 0, 0.1);
    }
    .numInputWrapper span:active {
      background: rgba(0, 0, 0, 0.2);
    }
    .numInputWrapper span:after {
      display: block;
      content: '';
      position: absolute;
    }
    .numInputWrapper span.arrowUp {
      top: 0;
      border-bottom: 0;
    }
    .numInputWrapper span.arrowUp:after {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 4px solid rgba(64, 72, 72, 0.6);
      top: 26%;
    }
    .numInputWrapper span.arrowDown {
      top: 50%;
    }
    .numInputWrapper span.arrowDown:after {
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 4px solid rgba(64, 72, 72, 0.6);
      top: 40%;
    }
    .numInputWrapper span svg {
      width: inherit;
      height: auto;
    }
    .numInputWrapper span svg path {
      fill: rgba(60, 63, 64, 0.5);
    }
    .numInputWrapper:hover {
      background: ${colors.white};
      color: ${filters.activeLight};
    }
    .numInputWrapper:hover span {
      opacity: 1;
    }
    .flatpickr-current-month {
      font-size: 135%;
      line-height: inherit;
      font-weight: 300;
      color: inherit;
      position: absolute;
      width: 75%;
      left: 12.5%;
      padding: 7.48px 0 0 0;
      line-height: 1;
      height: 34px;
      display: inline-block;
      text-align: center;
      transform: translate3d(0px, 0px, 0px);
    }
    .flatpickr-current-month span.cur-month {
      font-family: 'Montserrat', sans-serif;
      cursor: pointer;
      font-size: 12px;
      font-weight: 700;
      color: inherit;
      display: inline-block;
      margin-left: 0.5ch;
      padding: 0;
    }
    .flatpickr-current-month span.cur-month:hover {
      color: ${filters.activeLight};
    }
    .flatpickr-current-month .numInputWrapper {
      width: 45px;
      display: inline-block;
    }
    .flatpickr-current-month .numInputWrapper span.arrowUp:after {
      border-bottom-color: #3c3f40;
    }
    .flatpickr-current-month .numInputWrapper span.arrowDown:after {
      border-top-color: #3c3f40;
    }
    .flatpickr-current-month input.cur-year {
      background: transparent;
      box-sizing: border-box;
      color: inherit;
      cursor: text;
      padding: 0 0 0 0.5ch;
      margin: 0;
      display: inline-block;
      font-size: 12px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 300;
      line-height: inherit;
      height: auto;
      border: 0;
      border-radius: 0;
      vertical-align: initial;
      appearance: textfield;
    }
    .flatpickr-current-month input.cur-year:focus {
      outline: 0;
    }
    .flatpickr-current-month input.cur-year[disabled],
    .flatpickr-current-month input.cur-year[disabled]:hover {
      font-size: 100%;
      color: rgba(60, 63, 64, 0.5);
      background: transparent;
      pointer-events: none;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months {
      font-size: 13px;
      font-weight: 700;
      appearance: menulist;
      background: transparent;
      border: none;
      border-radius: 0;
      box-sizing: border-box;
      color: inherit;
      cursor: pointer;
      font-family: 'Montserrat', sans-serif;
      height: auto;
      line-height: inherit;
      margin: -1px 0 0 0;
      outline: none;
      padding: 0 0 0 0.5ch;
      position: relative;
      vertical-align: initial;
      width: auto;
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months:focus,
    .flatpickr-current-month .flatpickr-monthDropdown-months:active {
      outline: none;
    }
    .flatpickr-monthDropdown-months:hover {
      color: ${filters.activeLight};
    }
    .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
      background-color: transparent;
      outline: none;
      padding: 0;
    }
    .flatpickr-weekdays {
      width: 240px;
      background: transparent;
      text-align: center;
      overflow: hidden;

      margin: 0 10px;
      display: flex;
      align-items: center;
      height: 28px;
    }
    .flatpickr-weekdays .flatpickr-weekdaycontainer {
      padding-top: 5px;
      display: flex;
      flex: 1;
    }
    span.flatpickr-weekday {
      font-size: 9px;
      font-weight: 600;
      text-transform: uppercase;
      color: #616161;
      cursor: default;
      background: transparent;
      font-family: 'Montserrat', sans-serif;
      line-height: 1;
      margin: 0;
      text-align: center;
      display: block;
      flex: 1;
    }
    .dayContainer,
    .flatpickr-weeks {
      padding: 1px 0 0 0;
    }
    .flatpickr-days {
      width: 260px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: flex-start;
      padding: 0;
    }
    .flatpickr-days:focus {
      outline: 0;
    }
    .dayContainer {
      margin: 0 10px;
      width: 240px;
      min-width: 240px;
      max-width: 240px;

      padding: 0;
      outline: 0;
      text-align: left;

      box-sizing: border-box;
      display: inline-block;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      transform: translate3d(0px, 0px, 0px);
      opacity: 1;
    }
    .dayContainer + .dayContainer {
      box-shadow: -1px 0 0 #eee;
    }
    .flatpickr-day {
      width: 34px;
      height: 29px;
      line-height: 29px;
      color: #212121;

      background: none;
      box-sizing: border-box;
      cursor: pointer;
      font-weight: 400;
      flex-basis: 14.2857143%;

      margin: 0;
      display: inline-block;
      position: relative;
      justify-content: center;
      text-align: center;
    }
    .flatpickr-day:focus {
      color: red;
    }
    .flatpickr-day.inRange,
    .flatpickr-day.prevMonthDay.inRange,
    .flatpickr-day.nextMonthDay.inRange,
    .flatpickr-day.today.inRange,
    .flatpickr-day.prevMonthDay.today.inRange,
    .flatpickr-day.nextMonthDay.today.inRange,
    .flatpickr-day:hover,
    .flatpickr-day.prevMonthDay:hover,
    .flatpickr-day.nextMonthDay:hover,
    .flatpickr-day:focus,
    .flatpickr-day.prevMonthDay:focus,
    .flatpickr-day.nextMonthDay:focus {
      background-color: #ebeff7;
      color: ${colors.white};

      cursor: pointer;
      outline: 0;
    }
    .flatpickr-day.inRange,
    .flatpickr-day.prevMonthDay.inRange,
    .flatpickr-day.nextMonthDay.inRange,
    .flatpickr-day.today.inRange,
    .flatpickr-day.prevMonthDay.today.inRange,
    .flatpickr-day.nextMonthDay.today.inRange {
      background-color: rgba(225, 39, 95, 0.1);
    }
    .flatpickr-day.today:hover,
    .flatpickr-day.today:focus {
      background: #e1e1ef;
      color: ${colors.white};
    }
    .flatpickr-day.selected,
    .flatpickr-day.startRange,
    .flatpickr-day.endRange,
    .flatpickr-day.selected.inRange,
    .flatpickr-day.startRange.inRange,
    .flatpickr-day.endRange.inRange,
    .flatpickr-day.selected:focus,
    .flatpickr-day.startRange:focus,
    .flatpickr-day.endRange:focus,
    .flatpickr-day.selected:hover,
    .flatpickr-day.startRange:hover,
    .flatpickr-day.endRange:hover,
    .flatpickr-day.selected.prevMonthDay,
    .flatpickr-day.startRange.prevMonthDay,
    .flatpickr-day.endRange.prevMonthDay,
    .flatpickr-day.selected.nextMonthDay,
    .flatpickr-day.startRange.nextMonthDay,
    .flatpickr-day.endRange.nextMonthDay {
      color: ${colors.white};
    }
    .flatpickr-day.selected.startRange,
    .flatpickr-day.startRange.startRange,
    .flatpickr-day.endRange.startRange {
      border-radius: 4px;
    }
    .flatpickr-day.startRange.startRange::before {
      display: inline-block;
      position: absolute;
      content: '';
      width: 28px;
      height: 23px;
      background-color: rgba(225, 39, 95, 0.1);
      z-index: -1;
      left: 3px;
      top: 3px;
      border-radius: 3px;
    }
    .flatpickr-day.selected.startRange::before {
      display: inline-block;
      position: absolute;
      content: '';
      width: 28px;
      height: 23px;
      background-color: #e1275f;
      z-index: -1;
      left: 3px;
      top: 3px;
      border-radius: 3px;
    }
    .flatpickr-day.selected.endRange,
    .flatpickr-day.startRange.endRange,
    .flatpickr-day.endRange.endRange {
      border-radius: 4px;
    }
    .flatpickr-day.endRange.endRange::before {
      display: inline-block;
      position: absolute;
      content: '';
      width: 28px;
      height: 23px;
      background-color: rgba(225, 39, 95, 0.1);
      z-index: -1;
      left: 3px;
      top: 3px;
      border-radius: 3px;
    }
    .flatpickr-day.selected.endRange::before {
      display: inline-block;
      position: absolute;
      content: '';
      width: 28px;
      height: 23px;
      background-color: ${colors.active};
      z-index: -1;
      left: 3px;
      top: 3px;
      border-radius: 3px;
    }
    .flatpickr-day.selected.startRange.endRange,
    .flatpickr-day.startRange.startRange.endRange,
    .flatpickr-day.endRange.startRange.endRange {
      border-radius: 4px;
    }
    .flatpickr-day.inRange {
      border-radius: 0 !important;
    }
    .flatpickr-day.inRange::before {
      display: inline-block;
      position: absolute;
      content: '';
      width: 28px;
      height: 23px;
      background-color: rgba(225, 39, 95, 0.1);
      z-index: -1;
      left: 3px;
      top: 3px;
      border-radius: 3px;
    }
    .flatpickr-day.flatpickr-disabled,
    .flatpickr-day.flatpickr-disabled:hover,
    .flatpickr-day.prevMonthDay,
    .flatpickr-day.nextMonthDay,
    .flatpickr-day.notAllowed,
    .flatpickr-day.notAllowed.prevMonthDay,
    .flatpickr-day.notAllowed.nextMonthDay {
      color: #b8b8df;
      background: #f4f4fa;
      opacity: 0.65;
      cursor: default;
    }
    .flatpickr-day.flatpickr-disabled,
    .flatpickr-day.flatpickr-disabled:hover {
      cursor: default;
      border-radius: 0;
    }
    .flatpickr-day.week.selected {
      border-radius: 0;
    }
    .flatpickr-day.hidden {
      visibility: hidden;
    }
    .rangeMode .flatpickr-day {
      margin-top: 1px;
    }
    .flatpickr-weekwrapper {
      float: left;
    }
    .flatpickr-weekwrapper .flatpickr-weeks {
      padding: 0 12px;
      box-shadow: 1px 0 0 #eee;
    }
    .flatpickr-weekwrapper .flatpickr-weekday {
      float: none;
      width: 100%;
      line-height: 28px;
    }
    .flatpickr-weekwrapper span.flatpickr-day,
    .flatpickr-weekwrapper span.flatpickr-day:hover {
      display: block;
      width: 100%;
      max-width: none;
      color: rgba(64, 72, 72, 0.3);
      background: transparent;
      cursor: default;
      border: none;
    }
    .flatpickr-innerContainer {
      margin-top: 2px;

      display: block;
      display: flex;
      box-sizing: border-box;
      overflow: hidden;
    }
    .flatpickr-rContainer {
      display: inline-block;
      padding: 0;
      box-sizing: border-box;
    }
    .flatpickr-time {
      text-align: center;
      outline: 0;
      display: block;
      height: 0;
      line-height: 40px;
      max-height: 40px;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
    }
    .flatpickr-time:after {
      content: '';
      display: table;
      clear: both;
    }
    .flatpickr-time .numInputWrapper {
      flex: 1;
      width: 40%;
      height: 40px;
      float: left;
    }
    .flatpickr-time .numInputWrapper span.arrowUp:after {
      border-bottom-color: #404848;
    }
    .flatpickr-time .numInputWrapper span.arrowDown:after {
      border-top-color: #404848;
    }
    .flatpickr-time.hasSeconds .numInputWrapper {
      width: 26%;
    }
    .flatpickr-time.time24hr .numInputWrapper {
      width: 49%;
    }
    .flatpickr-time input {
      background: transparent;
      box-shadow: none;
      border: 0;
      border-radius: 0;
      text-align: center;
      margin: 0;
      padding: 0;
      height: inherit;
      line-height: inherit;
      color: #404848;
      font-size: 14px;
      position: relative;
      box-sizing: border-box;
      appearance: textfield;
    }
    .flatpickr-time input.flatpickr-hour {
      font-weight: bold;
    }
    .flatpickr-time input.flatpickr-minute,
    .flatpickr-time input.flatpickr-second {
      font-weight: 400;
    }
    .flatpickr-time input:focus {
      outline: 0;
      border: 0;
    }
    .flatpickr-time .flatpickr-time-separator,
    .flatpickr-time .flatpickr-am-pm {
      height: inherit;
      float: left;
      line-height: inherit;
      color: #404848;
      font-weight: bold;
      width: 2%;
      user-select: none;
      align-self: center;
    }
    .flatpickr-time .flatpickr-am-pm {
      outline: 0;
      width: 18%;
      cursor: pointer;
      text-align: center;
      font-weight: 400;
    }
    .flatpickr-time input:hover,
    .flatpickr-time .flatpickr-am-pm:hover,
    .flatpickr-time input:focus,
    .flatpickr-time .flatpickr-am-pm:focus {
      background: #f1f1f1;
    }
    .flatpickr-input[readonly] {
      cursor: pointer;
    }
    @keyframes fpFadeInDown {
      from {
        opacity: 0;
        transform: translate3d(0, -20px, 0);
      }
      to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
    }
    .flatpickr-calendar {
      width: 260px;
    }
    .dayContainer {
      padding: 0;
      border-right: 0;
    }
    span.flatpickr-day,
    span.flatpickr-day.prevMonthDay,
    span.flatpickr-day.nextMonthDay {
      border-radius: 4px;
      font-size: 11.4px;
      font-weight: 400;
      border-right-color: transparent;
    }
    span.flatpickr-day.prevMonthDay,
    span.flatpickr-day.nextMonthDay {
      border-radius: 0;
    }
    span.flatpickr-day:nth-child(n + 8),
    span.flatpickr-day.prevMonthDay:nth-child(n + 8),
    span.flatpickr-day.nextMonthDay:nth-child(n + 8) {
      border-top-color: transparent;
    }
    span.flatpickr-day:nth-child(7n-6),
    span.flatpickr-day.prevMonthDay:nth-child(7n-6),
    span.flatpickr-day.nextMonthDay:nth-child(7n-6) {
      border-left: 0;
    }
    span.flatpickr-day:nth-child(n + 36),
    span.flatpickr-day.prevMonthDay:nth-child(n + 36),
    span.flatpickr-day.nextMonthDay:nth-child(n + 36) {
      border-bottom: 0;
    }
    span.flatpickr-day:nth-child(-n + 7),
    span.flatpickr-day.prevMonthDay:nth-child(-n + 7),
    span.flatpickr-day.nextMonthDay:nth-child(-n + 7) {
      margin-top: 0;
    }
    span.flatpickr-day.today:not(.selected),
    span.flatpickr-day.prevMonthDay.today:not(.selected),
    span.flatpickr-day.nextMonthDay.today:not(.selected) {
      color: ${colors.active};
      font-weight: 700;
    }
    span.flatpickr-day.today:not(.selected):hover,
    span.flatpickr-day.prevMonthDay.today:not(.selected):hover,
    span.flatpickr-day.nextMonthDay.today:not(.selected):hover {
      border: 0;
    }
    span.flatpickr-day.startRange,
    span.flatpickr-day.prevMonthDay.startRange,
    span.flatpickr-day.nextMonthDay.startRange,
    span.flatpickr-day.endRange,
    span.flatpickr-day.prevMonthDay.endRange,
    span.flatpickr-day.nextMonthDay.endRange {
      background-color: rgba(225, 39, 95, 0.1);
      color: ${colors.white};
    }
    span.flatpickr-day.today,
    span.flatpickr-day.prevMonthDay.today,
    span.flatpickr-day.nextMonthDay.today,
    span.flatpickr-day.selected,
    span.flatpickr-day.prevMonthDay.selected,
    span.flatpickr-day.nextMonthDay.selected {
      z-index: 2;
      color: ${colors.white};
    }
    .rangeMode .flatpickr-day {
      margin-top: 1px;
    }
    .flatpickr-weekwrapper .flatpickr-weeks {
      box-shadow: none;
    }
    .flatpickr-weekwrapper span.flatpickr-day {
      border: 0;
      margin: -1px 0 0 -1px;
    }
    .hasWeeks .flatpickr-days {
      border-right: 0;
    }

    @media screen and (min-width: 0) and (min-resolution: +72dpi) {
      span.flatpickr-day {
        display: block;
        flex: 1 0 auto;
      }
    }
  }
`;
